import React from "react";
import "./section_header.scss";

const SectionHeader = ({ name }) => {
  return (
    <div className="section_header_main">
      <div className="section_header_container">
        <div className="section_box">
          <div className="section_box2"></div>
        </div>
        <h3>{name}</h3>
      </div>
    </div>
  );
};

export default SectionHeader;
